import { useState } from 'react';
import { addCart } from 'state/actions';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LocalizedLink from 'helpers/LocalizeLink';
import { setCheckoutCart } from 'state/actions';
import { getLocalePrefix } from '../../helpers/util';
import ApiService from 'services/api/api.service';
import Preloader from 'helpers/Preloader';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';


const ButtonTitle = (props) => {
    const auth = useSelector(store => store.auth)
    const { t } = useTranslation();

    const isPurchased = () => {
        return props?.item?.status !== undefined && props?.item?.status !== null
    }

    const title = props?.item?.price > 0 ?
        (props.isAddedToCart ? t('buttons.item_added_to_cart') : (isPurchased() ? t('buttons.item_purchased') : t('buttons.btn_add_to_cart'))) :
        t('buttons.Add to my strategies')

    return <>
        {
            props?.item?.price > 0 ?
                <i className="buy d-inline-block"></i>
                : <i className="add d-inline-block"></i>
        }
        <span className="d-inline-block text-white text-small text-semibold pl-5 pr-3">
            {
                auth ?
                    title
                    :
                    props?.item?.price > 0 ?
                        (t('buttons.btn_login_to_buy'))
                        :
                        (t('buttons.btn_login_to_add'))
            }
        </span>
    </>
}

const AddToCartButton = ({ isLoading, handlerAddToCart, isAddedToCart, ...props }) => {
    const element_name = 'add-to-cart-btn'
    const auth = useSelector(store => store.auth)
    return isLoading ? <Preloader /> : (<>
        {
            auth ?
                <a
                    data-test-id={props?.dti && props?.item?.price > 0 ? ("mrkt-addtocart-" + props.dti) : ("mrkt-addfree-" + props.dti)}
                    href={"#" + element_name}
                    className={"d-flex " + element_name}
                    onClick={(e) => { e.preventDefault(); handlerAddToCart(props.item) }}>
                    <ButtonTitle {...props} isAddedToCart={isAddedToCart} />
                </a>
                :
                <LocalizedLink to={'auth'} className={element_name}>
                    <ButtonTitle {...props} isAddedToCart={isAddedToCart} />
                </LocalizedLink>
        }
    </>)
}

export const CheckoutButton = (props) => {
    return <CartButton {...props} buttontype="checkout" />
}

export const AddToCart = (props) => {
    const dti = props.dti;
    return <CartButton {...props} buttontype="cart" dti={dti} />
}

export const CartButton = (props) => {
    let navigate = useNavigate();

    /*** checkout cart ***/
    const checkoutCart = useSelector(store => store.checkout_cart);
    const cart = useSelector(store => store.cart);
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const getCheckoutCart = (id) => {
        return checkoutCart[id]
    }

    const goCheckout = (e) => {
        e.preventDefault();

        if (cart.length === 0 && props?.item === undefined) {
            return
        }

        if (cart.length === 0) {
            goCheckoutNext(handlerAddToCart(props?.item))
            return
        }

        if (props.type !== "submit") {
            const cart_item = handlerAddToCart(props?.item);
            goCheckoutNext(cart_item)
            return
        }

        if (props?.callbefore) props.callbefore(goCheckoutNext)
        else goCheckoutNext()
    }

    const goCheckoutNext = (cart_item) => {
        let tempCart = {}

        const addItem = (item, index) => {
            if (item?.disabled !== true && item?.id) {
                if (tempCart[item["id"]]) {
                    tempCart[item["id"]].quantity += 1
                } else {
                    tempCart[item["id"]] = item
                    tempCart[item["id"]].quantity = 1
                    tempCart[item["id"]].price = item['price'] || item['price']
                    tempCart[item["id"]].checked = getCheckoutCart(item["id"]) ? getCheckoutCart(item["id"]).checked : true
                }
            }
            return tempCart
        }

        if (cart?.length > 0) {
            if (props.type !== 'submit') { addItem(cart_item) }
            cart.forEach(addItem)
        }
        else
            addItem(cart_item)

        if (props.type !== 'submit' && props.item && cart_item)
            for (let id in tempCart)
                tempCart[id].checked = cart_item.id.toString() === id;

        dispatch(setCheckoutCart(tempCart))
        navigate(getLocalePrefix() + "/checkout")
    }

    /*** add to cart ***/
    const [isLoading, setIsLoading] = useState(false)


    const isAddedToCart = () => {
        let added = false
        if (cart) {
            cart.forEach(element => {
                if (element.id === props?.item?.id) added = true;
            })
        };
        return added;
    }

    const handlerAddToCart = (item) => {
        if (!isAddedToCart()) {
            if (item.price > 0) {
                const cart_item = (
                    ({ id, name, description, price, type, img, seller_name, sales, tickets = null, start_at = null, options }) =>
                        ({ id, name, description, price, type, img, seller_name, sales, tickets, start_at, options }))(item);
                dispatch(addCart(cart_item));
                return cart_item
            }

            const url = 'strategies/' + item.id + '/duplicate';

            setIsLoading(true)
            ApiService.postData(url)
                .then((res) => {
                    setIsLoading(false)
                    Modal.info({
                        title: t("labels.strategy_added"),
                        content: t("strategy.strategy_added_message"),
                        closable: true
                    })
                })
                .catch((error) => {
                    setIsLoading(false)
                    let message = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString()

                    Modal.error({
                        title: "Error!",
                        content: message,
                        closable: true
                    })
                });
        } else {
            Modal.info({
                title: t("labels.strategy_already_added"),
                content: t("strategy.strategy_already_added_message"),
                closable: true,
                okButtonProps: { 'data-test-id': 'mrkt-modal-ok' },
                closeIcon: (<CloseOutlined data-test-id="mrkt-modal-x" />),
                wrapProps: { 'data-test-id': 'mrkt-modal-wr' }
            });
        }
        return null
    }


    return props.buttontype === 'checkout' ? (
        props.type === "localizedlink" ?
            <a data-test-id='checkout' className="btn noshadow h-42 px-12"
                href="#checkout"
                onClick={goCheckout}
            >
                {t("buttons.btn_checkout")}
            </a>
            :
            < button
                data-test-id='checkout'
                onClick={goCheckout}
                type={props.type === "submit" ? "submit" : "button"}
                className={"btn noshadow h-42 px-12" + (props.from === "strategy" ? " mt-3 mt-sm-0 ml-0 ml-md-3 mr-sm-4 order-3 w-xs-100" : " w-100")}
            >
                {
                    props.type === "submit" ?
                        t('buttons.btn_proced_to_checkout') :
                        t("buttons.btn_purchase")
                }
            </button >)
        : <AddToCartButton {...props} isLoading={isLoading} handlerAddToCart={handlerAddToCart} isAddedToCart={isAddedToCart()} />
};
